import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveCostRequestFailure({ uuid }) {
      const req = getState().find(({ cost }) => cost.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRemoveCostRequestPending({ uuid }) {
      const req = getState().find(({ cost }) => cost.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRemoveCostRequestSuccess({ uuid }) {
      const req = getState().find(({ cost }) => cost.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
